module.exports = __webpack_public_path__ + "img/img28.e39e6d96.svg";